import discounts from './discounts/discounts-v1';
import enterprises, { type Enterprises } from './enterprises/enterprises-v1';
import invoices from './invoices/invoices-v1';
import me from './me/me-v1';
import products from './products/products-v1';
import subscriptions, {
  type Subscriptions
} from './subscriptions/subscriptions-v1';
import users from './users/users-common';

export { type Enterprises, type Subscriptions };

export default {
  me,
  users,
  products,
  subscriptions,
  invoices,
  discounts,
  enterprises
};
